import React from 'react'
import { User } from '../user'
// import colors from '../../utils/colors'
import { CommentForm } from './comment-form'
import { useSelector } from 'react-redux'

const defaultPost = {
  title: 'Default Title'
}

const commentLabel = {
  en: 'comment on',
  id: 'komentar pada'
}

// const replyLabel = {
//   en: 'Reply',
//   id: 'Balas'
// }

const CommentSection = ({post = defaultPost, comments = [], onSubmit, ...props}) => {
  const language = useSelector(state => state.system.language)
  const { isLoggedIn, isOfficial } = useSelector(state => state.account)

  const canComment = isLoggedIn && !isOfficial

  return (
    <div>
      <h3 className="lg:text-2xl mb-5 lg:mb-8 uppercase font-bold">
        { comments.length } {commentLabel[language.name]} "{post.title}"
      </h3>
      <div
        className="overflow-y-auto w-full lg:w-7/12"
        style={{maxHeight: '50vh'}}
      >
        {
          comments.map((c, i) => (
            <div className={i < comments.length-1 ? `mb-5 lg:mb-8` : ''} key={i}>
              <User
                name={c.user.name}
                image={c.user.image}
                className="mb-5"
              />
              <p className="mb-4 text-sm text-gray-444">
                {c.date_by_language[language.name]}
              </p>
              <p
                className="mb-4 lg:mb-5 text-sm text-gray-444"
                style={{whiteSpace: 'pre-line'}}
              >
                "{c.text}"
              </p>
              {/* @todo: add "reply" feature */}
              {/* {
                canComment &&
                <div
                  className="rounded border text-primary text-xs text-center px-4 py-1 cursor-pointer inline-block"
                  style={{borderColor: colors.primary}}
                >
                  {replyLabel[language.name]}
                </div>
              } */}
            </div>
          ))
        }
      </div>

      {
        canComment &&
        <div className="w-full lg:w-7/12">
          <hr className="my-8" />

          <CommentForm onSubmit={onSubmit}/>
        </div>
      }
    </div>
  )
}

export { CommentSection }
